export default __webpack_public_path__ + "static/media/933.ac96ee78.png";